<template>
    <div class="reg-temp-content-area main-content-height dashabord-page p-5">
        <ReportNav />
        <div class="superadmin-dashboard-area">
            <div class="row">
                <div class="cols-sm-12 col-md-12 col-lg-12">
                    <h3 class="mb-4">Report by Product</h3>
                </div>
            </div>
            <div class="row mb-2 default-inputs search-date-range-wrap">
                <div class="col-sm-12 col-md-8 col-lg-8 text-left">
                    <div class="row">
                        <div class="col-sm-12 col-md-4 col-lg-4 mb-3 mb-md-0 mb-xl-0">
                            <label class="mb-0">Start date</label>
                            <vuejs-datepicker
                                initial-view="year"
                                maximum-view="year"
                                v-model="startDate"
                                :typeable="false"
                                :full-month-name="true"
                                :format="'yyyy-MM-dd'"
                                class="search-range"
                                id="search_start_date"
                                placeholder="YY-MM-DD"
                                :disabled-dates="{from: new Date()}"
                            ></vuejs-datepicker>
                        </div>
                        <div class="col-sm-12 col-md-4 col-lg-4 mb-3 mb-md-0 mb-xl-0">
                            <label class="mb-0">End date</label>
                            <vuejs-datepicker
                                initial-view="year"
                                maximum-view="year"
                                v-model="endDate"
                                :typeable="false"
                                :full-month-name="true"
                                :format="'yyyy-MM-dd'"
                                class="search-range"
                                id="search_end_date"
                                placeholder="YY-MM-DD"
                                :disabled-dates="{from: new Date()}"
                            ></vuejs-datepicker>
                        </div>

                        <div class="col-sm-12 col-md-4 col-lg-4">
                            <button @click="onFilterClick" class="btn btn-primary w-full rounded">Filter</button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="loaded">
                <WarrantyStatusPiechart :startDate="startDate" :endDate="endDate" ref="warrantyChart" />
                <WarrantyByProductsBarChart :startDate="startDate" :endDate="endDate" ref="warrantyBarChart" />
                <WarrantyEachHead :startDate="startDate" :endDate="endDate" ref="warrantyEachHead" />
            </div>
            <div v-else>
                <Loading />
            </div>
        </div>
    </div>
</template>

<script>
import WarrantyStatusPiechart from './pageComponents/WarranttyStatusPiechart.vue';
import WarrantyByProductsBarChart from './pageComponents/WarrantyByProductsBarchart.vue';
import WarrantyEachHead from './pageComponents/WarrantyEachHead.vue';
import Loading from '@/components/Loading.vue';
import moment from 'moment';
import ReportNav from '@/views/superadmin/pageComponents/report/Nav.vue';
export default {
    components: {
        WarrantyStatusPiechart,
        WarrantyByProductsBarChart,
        WarrantyEachHead,
        Loading,
        ReportNav
    },
    data() {
        return {
            startDate: moment().subtract(3, 'months').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
            loaded: true
        };
    },

    methods: {
        onFilterClick() {
            this.loaded = false;
            setTimeout(() => {
                this.loaded = true;
            }, 1000);
            // lets reload the compoenennt to pass the date and refetch data
        }
    }
};
</script>
